import { Avatar } from '@material-ui/core';
import React, {useState, useEffect} from 'react';
import './SidebarChat.css';
import db from "./firebase";
import { Link } from 'react-router-dom';

// to get a random avatar

function SidebarChat({addNewChat, id, name}) {

    const[seed, setSeed] = useState('');
    const[messages,setMessages] = useState("");
    useEffect(() => {
        setSeed(Math.floor(Math.random() * 5000));
    },[])

    useEffect(()=>{
        if(true ){
            db.collection('rooms').doc(id).collection('messages').orderBy('timestamp','desc')
            .onSnapshot((snapshot)=>(
                setMessages(snapshot.docs.map((doc)=>
                doc.data))      
            ))
        }
    },[id])

    const createChat = () => {
        const roomName = prompt("Please enter name for chat");
        if (roomName){
            //database stuff
            db.collection('rooms').add({
                name:roomName,
            })
        }
    };

    return !addNewChat ? (
        <Link to= {`/rooms/${id}`}>
              <div className="sidebarChat">
            <Avatar src= {`https://avatars.dicebear.com/api/human/${seed}.svg`}/>
        <div className="sidebarChat__info">
            <h2>{name}</h2>
    <p>{/*{messages[0]?.message}*/}
    Last Seen ...
           </p>
        </div>
            
        </div>
        </Link>
    ) : (
        <div onClick={createChat}
        className="sidebarChat">
            <h2>Add new Chat</h2>
        </div>
    )
}

export default SidebarChat
